import { createContext } from 'react';

export type LoaderContextType = {
    loading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    showLoader: () => void;
    hideLoader: () => void;
};

export const LoaderContext = createContext<LoaderContextType | undefined>(undefined);
